export default {
    AGENDADA: 'agendada',
    ESPONTANEA: 'espontanea',
}